import React from 'react';
import PropTypes from 'prop-types';

import FileDropZone from '../../../../common/components/FileDropZone/FileDropZone';
import EventListingsPhotoPreview from '../EventListingsPhotoPreview';
import styles from './EventListingsPhotoUploader.module.scss';
import MultimediaUploadErrorBanner from '../../../../pressrelease/editor/components/MultimediaUploadErrorBanner';

const EventListingsPhotoUploader = ({ value = null, onChange }) => {
  const [errors, setErrors] = React.useState([]); // eslint-disable-line no-unused-vars
  const handleAddingPhoto = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length) {
      // eslint-disable-next-line no-alert
      const flatFileRejections = rejectedFiles.map((err) => {
        if (err.errors[0]?.code === 'too-many-files') {
          return { fileName: err.file.name, code: 'multiple-files' };
        }
        return { fileName: err.file.name, code: err.errors[0]?.code };
      });
      setErrors(flatFileRejections);
      return;
    }
    onChange({ target: { name: 'deletePhoto', value: false } });
    onChange({ target: { name: 'photo', value: acceptedFiles[0] } });
  };

  const config = {
    accept: '.jpg,.jpeg,.png',
    maxFiles: 1,
    maxSize: 10000000, // 10MB
    multiple: false,
    noDrag: false,
    onDrop: handleAddingPhoto,
  };

  return (
    <>
      {errors.length > 0 && (
        <MultimediaUploadErrorBanner
          key={errors[0].fileName}
          error={errors[0].code}
          fileName={errors[0].fileName}
          handleBannerClose={() => setErrors([])}
        />
      )}
      {!value && (
        <FileDropZone
          config={config}
          mediaFileLimitReached={value !== null}
          buttonClass={styles.button}
          buttonText="Choose file"
          containerClass={styles.container}
          iconColor="#000"
        >
          <p className={styles.text} style={{ opacity: '1' }}>Drag and drop your logo here</p>
          <p className={styles.text} style={{ opacity: '1' }}>or</p>
        </FileDropZone>
      )}
      {value && <EventListingsPhotoPreview value={value} onChange={onChange} />}
    </>
  );
};

EventListingsPhotoUploader.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(File), PropTypes.string]),
  onChange: PropTypes.func.isRequired,
};

export default EventListingsPhotoUploader;
